import type {} from '@redux-devtools/extension'; // required for devtools typing
import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

type ConnectedRegisseurType = {
  identifiant: number | string;
  identifiantRegisseur: number;
  administrateur: boolean;
  mandat?: string;
};

type RegisseurStoreType = {
  regisseur: null | ConnectedRegisseurType;
  connect: (regisseur: ConnectedRegisseurType) => void;
  disconnect: () => void;
};

const useRegisseurStore = create<RegisseurStoreType>()(
  devtools(
    persist(
      (set) => ({
        regisseur: null,
        connect: (regisseur) => set({ regisseur }),
        disconnect: () => set({ regisseur: null }),
      }),
      {
        name: 'regisseur',
        storage: createJSONStorage(() => sessionStorage),
      },
    ),
  ),
);

export default useRegisseurStore;
